<app-header></app-header>
<app-hero></app-hero>
<main id="main">
  <app-about></app-about>
  <app-skills></app-skills>
  <app-resume></app-resume>
  <app-portfolio></app-portfolio>
  <app-contact></app-contact>
</main>
<app-footer></app-footer>
